// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Namvl","left":"styles_left__1aJM_","desktopActions":"styles_desktopActions__2DOgX","title":"styles_title__1rSI5"};